import * as React from 'react';

import type { } from '@mui/x-data-grid-pro/themeAugmentation';
import { GridRowModel, GridRowIdGetter } from '@mui/x-data-grid-pro';
import { useTheme } from '@mui/material';

import { useTranslations } from '@fenetech/translations';
import { useDashboardRMAData } from './useDashboardRMAData';
import { generateRMAColumns } from "./RMAsGridColumns";
import useIsMobile from 'helpers/hooks/useIsMobile';
import useUserInfo from "helpers/context/User/useUserInfo";
import CustomDataGridPro from "components/Common/CustomDataGridPro";

const RMAsGrid: React.FC<any> = (props: any) => {

  const tm = useTranslations();
  const theme = useTheme();
  const data = useDashboardRMAData();
  const isMobile = useIsMobile();
  const user = useUserInfo();

  const getRowId: GridRowIdGetter = (row: GridRowModel) => {
      return row.rmaKey;
  }

  const columns = React.useMemo(() => {
      return generateRMAColumns(tm, data, theme,isMobile, user);
  }, [tm, data, theme,isMobile, user]);

  return <>
      <CustomDataGridPro
          rows={data}
          columns={columns}
          getRowId={getRowId}
          tableName="DashboardRMA"
          tableSubName={isMobile ? "Mobile" : ""}
          hideInMobileColumns={[
            "date",
            "customerRef",
            "mfgSiteName"
          ]}
      />

  </>;
};

export default RMAsGrid;